import { Action } from 'state/actions';
import { FormRejectionsStateMap } from 'state/forms/rejections/model';
import { addOrReplaceKey, removeKey } from 'state/utils/collection';

export function rejectionsReducer(state: FormRejectionsStateMap = {}, action: Action): FormRejectionsStateMap {
  switch (action.type) {
    case 'WORKSPACE_RESET_TAB_REQUESTED':
      return removeKey(state, action.tabId);
    case 'PRODUCT_CODES_REQUESTED':
    case 'STREAMING_QUOTE_ACKED':
      return addOrReplaceKey(state, action.tabId, { errors: [] });
    case 'STREAMING_QUOTE_FAILED':
    case 'PRODUCT_CODES_REJECTED':
      return addOrReplaceKey(state, action.tabId, { errors: action.errors });
    case 'STREAMING_QUOTE_REJECTED':
      return addOrReplaceKey(state, action.tabId, {
        errors: [{ originMessage: action.error }],
      });
    case 'QUOTE_TRADE_REJECTED':
      return addOrReplaceKey(state, action.tabId, { errors: action.rejections });
    case 'WORKSPACE_TAB_REMOVED':
      return removeKey(state, action.id);

    default:
      return state;
  }
}
